import postCreateDetailedMinutes from "@/services/postCreateDetailedMinutes";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export interface CreateDetailedMinutesData {
  recordingId: string;
}

const usePostCreateDetailedMinutes = () => {
  const { mutate, mutateAsync, isPending, isError, error, isSuccess, status } = useMutation<boolean, AxiosError, CreateDetailedMinutesData>({
    mutationFn: async (data: CreateDetailedMinutesData) => {
      const result = await postCreateDetailedMinutes(data);
      if (result instanceof AxiosError) {
        throw result;
      }

      return result;
    },
    mutationKey: ["postCreateDetailedMinutes"],
    onError: (error: AxiosError) => {
      reportError({
        eventName: "POST-CREATE-EXTENDED-MINUTES-ERROR",
        properties: {
          reason: `Error with create Extended minutes - ${error?.message}`,
        },
      });
    },
  });

  return { mutate, mutateAsync, isPending, isError, error, isSuccess, status };
};

export default usePostCreateDetailedMinutes;
